import React from 'react';

const BubbleText = ({ text, startColor = '#003f5c', midColor = '#bc5090', endColor = '#ffa600' }) => {
  return (
    <span style={{
      fontSize: '4rem',  // Adjusted size to prevent it from overwhelming
      fontWeight: 700,   // Slightly lighter boldness for elegance
      background: `linear-gradient(90deg, ${startColor} 0%, ${midColor} 50%, ${endColor} 100%)`,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      display: 'inline-block', // Helps keep proper alignment
      padding: '10px 20px',  // Adds padding for better spacing
      textAlign: 'center',
      textShadow: `0 4px 8px rgba(0, 0, 0, 0.25)`,  // Subtle but effective shadow for depth
    }}>
      {text}
    </span>
  );
};

export default BubbleText;
